import React from 'react'
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table'
import { StatusBadge } from '@/components'
import Amount from '../../Amount'
import TransactionsTableSkeleton from '../../../home-page/transactions-table.skeleton'
import { format } from 'date-fns'
import { TransactionTableHeader } from './transaction-table-header'
import PropTypes from 'prop-types'
import { Divider } from '@/components'
import { convertUTCToET } from '@/utils/date-format-util'

const PendingTransactionsTable = ({ data, page }) => {
  const renderTableRows = () => {
    return data?.map((transaction, index) => {
      return (
        <React.Fragment key={transaction?.id + index}>
          <TableRow data-testid="transaction-table-row">
            <TableCell className="font-normal text-sm text-dGray-600 md:table-cell hidden italic ">
              <div className="flex items-center ">
                <span>{format(new Date(convertUTCToET(transaction.node?.createdAt)), 'MMM dd, yyyy') ?? '-'}</span>
              </div>
            </TableCell>
            <TableCell className="md:hidden table-cell text-left pl-1">
              <div className="flex flex-col items-start ">
                {transaction?.node.source && Object.keys(transaction.node.source).length > 0 ? (
                  <div className="font-medium italic text-sm leading-5 text-dGray-900">
                    {transaction?.node.source.transactionEvents[0].merchantDetails.description}
                  </div>
                ) : (
                  <div className="flex items-center italic font-medium text-sm">Payment - Thank You</div>
                )}
                <span className="font-inter font-normal italic text-sm leading-5 text-dGray-600">
                  {format(new Date(convertUTCToET(transaction.node?.createdAt)), 'MMM dd, yyyy')}
                </span>
              </div>
            </TableCell>
            <TableCell className="hidden md:table-cell">
              <div className="flex items-center italic">
                <StatusBadge status={'pending'} />
              </div>
            </TableCell>
            <TableCell className="font-medium text-sm hidden text-dGray-900 md:table-cell">
              {transaction?.node.source && Object.keys(transaction.node.source).length > 0 ? (
                <div className="flex items-center italic">
                  {transaction?.node?.source?.transactionEvents[0]?.merchantDetails?.name}
                </div>
              ) : (
                <div className="flex items-center italic">Payment - Thank You</div>
              )}
            </TableCell>
            <TableCell className="font-bold text-nowrap text-sm text-dGray-600 hidden md:table-cell"></TableCell>
            <TableCell className="flex flex-col">
              <div className="flex flex-col items-end md:items-start italic">
                <Amount
                  amount={transaction?.node.pendingAmount.value}
                  sign={
                    transaction?.node.source && Object.keys(transaction.node.source).length > 0
                      ? null
                      : transaction?.node.sign
                  }
                  customColor={
                    transaction?.node.source && Object.keys(transaction.node.source).length > 0
                      ? 'text-dGray-600'
                      : 'text-success-600'
                  }
                />
                <div className="md:hidden">
                  <StatusBadge status={'pending'} />
                </div>
              </div>
            </TableCell>
          </TableRow>
        </React.Fragment>
      )
    })
  }

  return (
    <div className="w-full h-auto py-1 px-0 ">
      <div className={`flex flex-row justify-between items-center mb-5 ${page === 'home' ? '-mt-2' : 'mt-6'}`}>
        <p className="font-semibold text-lg text-[--gray-900]">Pending Transactions</p>
      </div>
      <div className="md:px-0 px-3">
        {!data ? (
          <TransactionsTableSkeleton />
        ) : (
          <Table>
            {data?.length > 0 ? (
              <>
                <TransactionTableHeader transactionType="pending" page={page} />
                <TableBody>{renderTableRows()}</TableBody>
              </>
            ) : (
              <p className="font-normal text-sm text-dGray-600 w-full my-5">No pending transactions available</p>
            )}
          </Table>
        )}
        <div className="md:w-full px-0 md:px-0">
          <Divider />
        </div>
      </div>
    </div>
  )
}

export default PendingTransactionsTable

PendingTransactionsTable.propTypes = {
  data: PropTypes.object,
  page: PropTypes.string,
}
